<template>
  <!-- 薪资方案 -->
  <div class="SalarPlan">
    <el-form class="demo-form-inline" label-width="80px"  >

      <el-form-item label="方案名称:"  style="margin-right: 20px;">
        <el-input placeholder="请输入方案名称" v-model="values1"></el-input>
      </el-form-item>

      <el-form-item label="方案类型:" style="margin-right: 20px;">
        <el-select v-model="values2" placeholder="请选择方案类型" clearable>
          <el-option v-for="item in optionPlan2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="方案状态:" style="margin-right: 20px;">
        <el-select v-model="values3" placeholder="请选择方案状态"  clearable>
          <el-option v-for="item in optionPlan3" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>


      <!-- <el-form-item label="时间类型:" style="margin-right: 20px;">
        <el-select v-model="values4" placeholder="请选择时间类型"  clearable>
          <el-option v-for="item in optionPlan4" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="时间状态:" style="margin-right: 20px;">
        <el-select v-model="values5" placeholder="请选择时间状态"  clearable>
          <el-option v-for="item in optionPlan3" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item> -->


    </el-form>

    <div style="width: 100%; display: flex; justify-content: flex-end; margin-bottom: 20px; margin-top: 20px">
        <el-button type="primary" @click="addProgramme1" class="btns" size="small" icon="el-icon-plus">添加方案</el-button>
        <el-button type="primary" @click="addProgramme11" class="btns" size="small" icon="el-icon-search">查询</el-button>
        <el-button type="primary" @click="addProgramme111" class="btns" size="small" icon="el-icon-close">清空</el-button>
    </div>

    <el-table border :data="planArrs" height="850" style="width: 100%" >
      <el-table-column prop="name" label="方案"></el-table-column>
      <el-table-column prop="typeStr" label="方案类型"></el-table-column>
      <el-table-column prop="statusStr" label="方案状态"></el-table-column>

      <el-table-column prop="timeTypeStr" label="时间类型"></el-table-column>
      <el-table-column prop="timeStateStr" label="时间状态"></el-table-column>

      <el-table-column label="操作" width="150" >
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="delPlan(scope.row.id)">删除</el-button> -->
          <!-- <el-button type="text" size="small" @click="planDetailFun(scope.row.id)">详情</el-button> -->
          <el-button type="text" size="small" @click="editPlan3(scope.row)">编辑</el-button>
          <!-- <el-button type="text" size="small" @click="editPlan1(scope.row.id)">复制</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="planList.pageNum" :page-size="planList.pageSize" layout="total, prev, pager, next"
      :total="planList.total"></el-pagination>







   <el-dialog append-to-body :title="isShows ? '添加方案' : '修改方案'" :visible.sync="addProgramme1show" width="60%" center :before-close="handleaddProgramme1show">

        <div style="margin-bottom: 20px;">
          <el-button :class=" isShow_type === '1' ? 'btns' : '' "  size="small"  @click="handleseachRestAddShowSava1('1')">月</el-button>
          <el-button :class=" isShow_type === '2' ? 'btns' : '' "  size="small"  @click="handleseachRestAddShowSava1('2')">季度</el-button>
          <el-button :class=" isShow_type === '3' ? 'btns' : '' "  size="small"  @click="handleseachRestAddShowSava1('3')">年</el-button>
        </div>

        <el-form>

          <el-form-item label="方案名称" >
            <el-input placeholder="请输入方案名称" v-model="input1"></el-input>
          </el-form-item>

          <el-form-item label="方案类型:">
            <el-select v-model="input2" style="width:100%;" placeholder="请选择方案类型">
                <el-option v-for="item in optionPlan2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="时间类型:">
            <el-select v-model="input4" style="width:100%;" placeholder="请选择时间类型" @change="handleTimeTypeChange">
                <el-option v-for="item in optionPlan4" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          

          <el-form-item label="方案状态:"  v-if="!isShows">
            <el-select v-model="input3" style="width:100%;" placeholder="请选择方案状态下">
                <el-option v-for="item in optionPlan3" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="方案详情:" v-if="type === '底薪增幅方案'">
            <el-form-item>
              <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput11('底薪增幅方案')"></el-button>
              <el-button size="small" icon="el-icon-remove-outline" @click="removeItem11(1)"></el-button>
            </el-form-item>
            <el-form-item>

              <div v-for="(item, index) in renewalCollectionListWay" :key="index" style="margin-bottom: 20px;">
                <el-card style="margin-top: 20px;">
                  <el-form-item style="margin-left: 74px;">
                    <div style="width: 100%;">
                      <div v-for="(subItem, subIndex) in item" :key="subIndex">

                        <!-- <div style="display: flex;" v-if="input4 === 1 && subItem.months !== undefined">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;">{{ isShow_type === '2' ? index + 1 + '季度' : '月份' }}:</span>
                          <el-date-picker :disabled="true"  v-model="subItem.months"   type="monthrange"   value-format="yyyy-MM"   range-separator="至"   start-placeholder="开始月份"  format="MM"  end-placeholder="结束月份"   clearable   style="margin: 10px 0px 0px 0px; margin-left: 15px; width: 50%;"> </el-date-picker>
                        </div>

                        <div style="display: flex;" v-if="input4 === 2 && subItem.months !== undefined">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;">{{ isShow_type === '2' ? index + 1 + '季度' : '月份' }}:</span>
                          <el-date-picker    :formatter="monthFormatter" @change="handleDateChange" @focus="handlefocus('1',subItem.months,index,subIndex)" v-model="subItem.months"  format="MM"  type="monthrange"   value-format="yyyy-MM"   range-separator="至"   start-placeholder="开始月份"    end-placeholder="结束月份"   clearable   style="margin: 10px 0px 0px 0px; margin-left: 15px; width: 50%;"> </el-date-picker>
                        </div> -->

                        <div style="display: flex;width: 100%;">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;" v-if="subIndex === 0">{{ isShow_type === '2' ? index + 1 + '季度' : '月份' }}: </span>

                          <div v-if="(isShow_type === '2' || isShow_type === '3') && subIndex === 0" style="width: 100%;" >
                            <el-date-picker @change="handleDateChange(1,subItem.months,index,subItem.monthss,subIndex)" @focus="savePrevDate(1,index,subIndex)" v-model="subItem.months" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 28px; margin-right: 3px;">  </el-date-picker>
                            <span>至</span>
                            <el-date-picker @change="handleDateChange(2,subItem.monthss,index,subItem.months,subIndex)" @focus="savePrevDate(2,index,subIndex)" v-model="subItem.monthss" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 5px;">  </el-date-picker>
                          </div>

                          <div v-if="(isShow_type === '1' && input4 === 1) && subIndex === 0" style="width: 100%; display: flex; line-height: normal;">
                            <el-date-picker  v-model="subItem.months" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 28px; margin-right: 11px; ">  </el-date-picker>
                            <span style="padding-top: 9px;">至</span>
                            <el-date-picker  v-model="subItem.monthss" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 15px; margin-right: 3px; ">  </el-date-picker>
                          </div>

                          <div v-if="(isShow_type === '1' && input4 === 2) && subIndex === 0" style="width: 100%;">
                            <el-date-picker  v-model="subItem.months"  :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 28px; margin-right: 3px; width: 50%;">  </el-date-picker>
                          </div>

                        </div>

                        <div style="display: flex; margin-top: 20px;">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;">业绩标准: </span>
                          <el-input style="margin: 10px 0px 0px 0px; width: 20%;margin-left: 15px; width: 50%;"    placeholder="请输入业绩标准"   v-model="subItem.maxAmount">
                          </el-input>
                        </div>

                        <div style="display: flex;">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;">奖励全额：</span>
                          <el-input style="margin: 10px 0px 0px 0px; width: 20%;margin-left: 15px; width: 50%;"  placeholder="请输入增幅金额"   v-model="subItem.commissionRate">
                          </el-input>
                        </div>

                      </div>
                    </div>

                    <el-form-item v-if="item && item.length > 0">
                      <div style="width: 80%; display: flex; justify-content: end;">
                        <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput111(index)"></el-button>
                        <el-button size="small" icon="el-icon-remove-outline" @click="removeItem111(index)"></el-button>
                      </div>
                    </el-form-item>

                  </el-form-item>
                </el-card>
              </div>
            </el-form-item>
          </el-form-item>


          <el-form-item label="方案详情:" v-if="type === '现金奖励方案'">

             <el-form-item>
                <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput11"></el-button>
                <el-button size="small" icon="el-icon-remove-outline" @click="removeItem11"></el-button>
             </el-form-item>

            <el-form-item>
              
               <div v-for="(itme,index) in renewalCollectionListWay" :key="index" style="margin-bottom: 20px; ">
                <el-card style="margin-top: 20px;">
                  <el-form-item style="margin-left: 74px;" >
                      <div style="width: 100%; margin-bottom: 10px;">

                        <!-- <div style="display: flex; width: 100%;" v-if="input4 === 1">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;">{{ isShow_type === '2' ? index + 1 + '季度' : '月份' }}: </span>
                          <el-date-picker :disabled="true"  v-model="itme.months" type="monthrange"  value-format="yyyy-MM"  range-separator="至" start-placeholder="开始日期" format="MM" end-placeholder="结束日期"  clearable style="margin: 10px 0px 0px 0px; margin-left: 15px; width: 50%; "></el-date-picker>
                        </div> -->

                        <div style="display: flex;width: 100%;">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;">{{ isShow_type === '2' ? index + 1 + '季度' : '月份' }}: </span>
                          <!-- <el-date-picker v-if="isShow_type === '1'" ref="monthPicker"   :picker-options="{ onPick: (val) => onMonthPick(val, index) }"  :formatter="monthFormatter" @change="handleDateChange" @focus="handlefocus('2',itme.months,index)" v-model="itme.months" type="monthrange"  format="MM" value-format="yyyy-MM"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"  clearable style="margin: 10px 0px 0px 0px; margin-left: 15px; width: 50%; "> </el-date-picker>
                          <el-date-picker v-if="isShow_type === '2' || isShow_type === '3'" :formatter="monthFormatter" @change="handleDateChange($event, index)" @focus="savePrevDate('range',index)" v-model="itme.months" type="monthrange"  format="MM" value-format="yyyy-MM"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"  clearable style="margin: 10px 0px 0px 0px; margin-left: 15px; width: 50%; "> </el-date-picker> -->
                          
                          <!-- <el-date-picker :formatter="monthFormatter" @change="handleDateChange" @focus="handlefocus('2',itme.months,index)" v-model="itme.months" type="monthrange"  format="MM" value-format="yyyy-MM"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"  clearable style="margin: 10px 0px 0px 0px; margin-left: 15px; width: 50%; "> </el-date-picker> -->
                          
                          <div v-if="isShow_type === '2' || isShow_type === '3'" style="width: 100%;" >
                            <el-date-picker @change="handleDateChange1(1,itme.months,index,itme.monthss)" @focus="savePrevDate(1,index)" v-model="itme.months" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 28px; margin-right: 3px;">  </el-date-picker>
                            <span style="padding-top: 9px;">至</span>
                            <el-date-picker @change="handleDateChange1(2,itme.monthss,index,itme.months)" @focus="savePrevDate(2,index)" v-model="itme.monthss" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 5px;">  </el-date-picker>
                          </div>

                          <div v-if="isShow_type === '1' && input4 === 1" style="width: 100%; display: flex; line-height: normal;">
                            <el-date-picker  v-model="itme.months" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 28px; margin-right: 11px; ">  </el-date-picker>
                            <span>至</span>
                            <el-date-picker  v-model="itme.monthss" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 15px; margin-right: 3px; ">  </el-date-picker>
                          </div>

                          <div v-if="isShow_type === '1' && input4 === 2" style="width: 100%;">
                            <el-date-picker  v-model="itme.months" :disabled="input4 === 1" type="month"  format="MM" placeholder="选择月" style="margin-left: 28px; margin-right: 3px; width: 50%;">  </el-date-picker>
                          </div>
                     
                        </div>

                        <div style="display: flex;width: 100%;">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;">业绩标准: </span>
                          <el-input style="margin: 10px 0px 0px 0px; margin-left: 15px; width: 50%;" placeholder="请输入业绩标准" v-model="itme.maxAmount"></el-input>
                        </div>

                        <div style="display: flex;width: 100%;">
                          <span style="margin-top: 10px; width: 110px; margin-left: 20px;">奖励全额：</span>
                          <el-input style="margin: 10px 0px 0px 0px; margin-left: 15px; width: 50%; " placeholder="请输入增幅金额" v-model="itme.commissionRate"></el-input>
                        </div>

                      </div>
                  </el-form-item>
                </el-card>
              </div>

            </el-form-item>
          </el-form-item>


        </el-form>

       
        <span slot="footer" class="dialog-footer" style="margin: 20px 0px;">
          <el-button size="small" @click="handleaddProgramme1show">取消</el-button>
          <el-button size="small" type="primary" @click="handleseachRestAddShowSava">保存</el-button>
        </span>
    </el-dialog>









  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
// import SalarPlanDialog from "./SalarPlanDialog.vue";
export default {
  // components: {
  //   SalarPlanDialog
  // },
  props:{
    type:{
      type: String,
      default:''
    },
    objUrl:{
      type: Object,
      default:{
        
      }
    }
  },
  data () {
    return {

       

      isShow_type: '1',

      maxAmount: '',
      commissionRate: '',

     renewalCollectionListWay: [],
     ids: '',
     lePersList1:[],


     values1:'',
     values2:'',
     values3:'',


     values4:'',
     values5:'',

     optionPlan1:[],
     optionPlan2:[{ id: 1, name: '销售' },{ id: 2, name: '规划师' }],
     optionPlan3:[{ id: 0, name: '禁用' },{ id: 1, name: '启用' }],

     input1:'',
     input2:'',
     input3:'',

     input4:'',
     optionPlan4:[{ id: 1, name: '自然' },{ id: 2, name: '自定义' }],
     

     obligationDialog1:false,
     obligationShow1:'',

     obligationDialog2:false,
     obligationShow2:'',

    // addMoon:[],
     addMoon:{
        dutyId:'',
        isMoon:'',
      },
     index:'',
     isMoonShow:false,
     text: '+∞',
     num: "0",
     num1: "0",
     addObj: {
        interpolateName: "",
        planList: [],
      },
      addObj1: {
        interpolateName: "",
        interpolateNames: "",
        planList: [],
      },
      moonVisible: false,
      MoonInterpolatList:[],
        viewObj: {
        planName: "",
        planList: [],
      },
      interpolateNamesoptions:[
        {
          value: 1,
          label: '网课'
        },
        {
          value: 2,
          label: '上门'
        },
        {
          value: 3,
          label: '门店'
        },
      ],

      interpolateNamesoptions1:[
        {
          value: 1,
          label: '小学'
        },
        {
          value: 2,
          label: '初高'
        }
      ],

      Deduction1:'',
      Deduction2:'',
      Deduction3:'',
      Deduction4:'',

      activeName: '',
      activeName1: '',
      activeName2: '',
      activeName3: '',
      activeName4: '',
      activeNames: '',
      isShowDialog:false,
      optionPlan: [],
      values: '',
      dialogVisible1: false,
      detilObj: {
      },
      detilShow: false,//详情显示隐藏
      classTypeArr: [{
        value: 1,
        name: '1v1'
      }, {
        value: 2,
        name: '1v2'
      }, {
        value: 3,
        name: '1v3'
      },
      ],
      planNames: "",
      titleText: true,
      dutyObj: {//义务课时费绑定
        dutyClassFee: "",//义务课时费
        dutyClassNum: "",//义务课时数
        id: ""
      },
      PlanDutyList: [],//义务课时选择
      PlanDutyList1: [],//义务课时选择
      PlanDutyList2: [],//义务课时选择

      planArr: [],//所有方案
      GradeOneManyArr: [],//小学生一对多奖励表格
      ExceTableData: [],//超课次后每节课奖励表格
      onManyTableData: [],//超课次后一对多奖励表格
      toDayTableData: [],//当天超课次奖励
      studentCoursesTableData: [],//学生课程累计奖励
      GradeOneManyList: {//小学生一对多奖励分页
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      planName: "",//方案名称搜索
      planList: {//所有方案分页
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      onManyList: {
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      PlanExecList: {
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      toDayList: {
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      studentCoursesList: {
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },

      addPlan: {//添加方案
        isDay1: false,
        dutyId2:'',
        isDuty1: false,
        id: "",
        dutyId: '',//义务课时费表id
        dutyId1: '',
        planName: "",//方案名称
        isRecommender: false,//是否选了内推奖励
        recommenderFee: "",//内推奖励金额
        day: "",
        isDuty: false,
        isClassFee: false,
        isMoon:false,
        isDay:false,
        execId: [],//超课次表id
        jobBasepay: "",//底薪
        classFeeId: "",//课时费表id
        dutyMonth: "",//义务课时费有效期
        isGradeOneMany: false,//是否选了小学生一对多 0否 1是
        isExce: false,//是否选了超课次 0否 1是
        isExceOnemany: false,//是否选了超课次后一对多奖励 0否 1是
        isExceDay: false,//是否选了当天超课次 0否 1是
        isStudentTotal: false,//是否选了学生课程累计 0否 1是
        exceDayId: [],//当天超课次表id
        exceOnemanyId: [],//超课次一对多奖励表id
        gradeOneManyId: [],//小学生一对多表id
        studentTotalId: [],//学生课程累计表id
      },
      pupilShow: true,// 判断小学生一对多奖励是添加或者编辑
      pupilDialog: false,
      exceedShow: true,//判断超课次后每节课奖励是添加还是编辑
      exceedDialog: false,
      onManyShow: true,//判断超课次形式奖励是添加还是编辑
      onManyDialog: false,
      toDayShow: true,//判断当天超课次奖励是添加还是编辑
      toDayDialog: false,
      studentCoursesShow: true,//判断学生课程累计奖励是添加还是编辑
      studentCoursesDialog: false,
      isShow: true,//根据该字段判断是添加还是编辑
      showDialog: false,//添加方案显示隐藏
      obligationDialog: false,//义务课时方案
      obligationShow: false,//据该字段判断是添加还是编辑
      pupilObj: {//小学生一对多奖励添加编辑弹窗
        id: '',
        month: "",//月份
        classType: "",//上课形式
        fee: '',//奖励金额
      },
      exceedObj: {//超课次后每节课奖励
        id: '',
        month: "",//月份
        basicClassNum: "",//基础课时数
        excePredictFee: "",//超预计课程奖励
      },
      onManyObj: {//超课次后一对多奖励
        basicClassNum: "",//基础课时数
        grade: "",//学段
        classType: "",//上课形式
        fee: "",//奖励金额
        id: ''
      },
      toDayObj: {//当天超课次奖励
        id: "",
        month: "",//月份
        dayExceClassNum: "",//当天超过课时数
        dayExceClassFee: "",//超课次奖励
      },
      studentCoursesObj: {//学生课程累计
        id: "",
        month: '',//月份
        classTimeNum: "",//课时数
        classTimeFee: "",//课时费
      },
      arr: [{ grade: "", educationType: "", classFee: "" }],
      planDetails: [{ gradeName: "", educationType: "", classFee: "" }],
      checkList: [],//小学生一对多奖励月份
      checkList2: [],//超课次后每节课奖励月份
      checkList3: [],//超课次后一对多奖励月份
      checkList4: [],//当天超课次奖励月份
      checkList5: [],//学生课程累计奖励
      value: '',
      options: [{
        value: "1",
        label: '小学'
      }, {
        value: "2",
        label: '初中'
      }, {
        value: "3",
        label: '高中'
      }, {
        value: "4",
        label: '规划课'
      }, {
        value: "5",
        label: '家庭教育课'
      }],

      options1: [{
        value: 1,
        label: '规划'
      }, {
        value: 2,
        label: '线下'
      }],

      educationType: [{ value: "1", label: '网课' }, { value: "2", label: '线下' }, { value: "3", label: '门店' }],
      obligationList: [
        {
          id: '1',
          name: '入职1个月'
        },
        {
          id: '2',
          name: '入职2个月'
        },
        {
          id: '3',
          name: '入职3个月'
        },
        {
          id: '4',
          name: '入职4个月',
        }, {
          id: '5',
          name: '入职5个月'
        }
        , {
          id: '6',
          name: '入职6个月'
        }
        , {
          id: '7',
          name: '入职7个月'
        }
        , {
          id: '8',
          name: '入职8个月'
        }
        , {
          id: '9',
          name: '入职9个月'
        }
        , {
          id: '10',
          name: '入职10个月'
        }
        , {
          id: '11',
          name: '入职11个月'
        }
        , {
          id: '12',
          name: '入职12个月'
        }
      ],
      dialogVisible: false,

      isExpand: 0,
      expandFee: '',


      dutyClassFee: "",
      dutyClassNum: "",


      socialSecurityFee: "",
      socialSecurityWithholdFee: "",

      isSocialSecurity: "",
      isSocialSecurityWithhold: "",


      activeName5: "",
      activeName5s: "",


      addProgramme1show:false,
      isShows: false,

      planArrs: [],

      focusObj: {},

      useResult: undefined,

      copyList: [],
      copyType: 0,

    }
  },
  created () {
    // this.getOptions()
    // this.getPupilList()
    // this.getOnMany()
    // this.getPlanExec()
    // this.getOnMany()
    // this.getToDay()
    // this.getStudentCourses()
    // this.getPlanData()
    // this.salaryPlanDuty()
    // this.getListArr()
    // this.getPlanList()
    // this.getMoonInterpolatList()
  },
  mounted(){
    if(this.currentRow){
       this.addPlan.id = this.currentRow.id
    }
    this.handleinitlist()
    this.handleGetInitAll()

  },
  methods: {

  

    monthFormatter(date) {
      if (!date) return '';
      const month = date.getMonth() + 1;
      return `${month}月`;
    },


    handlefocus(type,value,index,subIndex){
      if(type === '1'){
        this.focusObj = {
          focusValue: value,
          index: index,
          subIndex: subIndex
        }
      }

      if(type === '2'){
        this.focusObj = {
          focusValue: value,
          index: index,
        }
      }
    },

    // 保存当前行或子项旧的月份值，用于无效选择时回退
    savePrevDate(type,index,subIndex) {
      if (!this._prevMonths) this._prevMonths = {}
      const key = index + '_' + (typeof subIndex !== 'undefined' ? subIndex : 'root')
      let item
      if (typeof subIndex !== 'undefined' && this.renewalCollectionListWay[index] && this.renewalCollectionListWay[index][subIndex]) {
        item = this.renewalCollectionListWay[index][subIndex]
      } else {
        item = this.renewalCollectionListWay[index]
      }
      this._prevMonths[key] = { months: item ? item.months : '', monthss: item ? item.monthss : '' }
    },


   handleDateChange(...args) {
      try {
        // 支持两种调用：1) 月区间选择器会传入单个数组 value
        // 2) 单月开始/结束选择器以 (type,val,index,month,subIndex?) 调用
        if (args.length >= 1 && Array.isArray(args[0])) {
          const [startDate, endDate] = args[0];
          // 如果删除了时间，直接返回true
          if (!startDate || !endDate) {
            return true;
          }
          const rangeIndex = args.length > 1 ? args[1] : undefined;
          const start = new Date(startDate);
          const end = new Date(endDate);
          if (isNaN(start.getTime()) || isNaN(end.getTime())) return true;
          // 计算月份差值（包含边界月份）
          const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1;
          // key for prev cache
          const key = typeof rangeIndex !== 'undefined' ? rangeIndex + '_range' : null;
          // 验证并还原
          if (this.isShow_type === '2' && months < 3) {
            this.$message.warning('请选择连续的三个月');
            if (key !== null && this._prevMonths && this._prevMonths[key]) {
              const prev = this._prevMonths[key];
              if (typeof rangeIndex !== 'undefined' && this.renewalCollectionListWay[rangeIndex]) {
                this.$set(this.renewalCollectionListWay[rangeIndex], 'months', prev);
              }
            }
            return false;
          }
          if (this.isShow_type === '3' && months < 12) {
            this.$message.warning('请选择连续的12个月');
            if (key !== null && this._prevMonths && this._prevMonths[key]) {
              const prev = this._prevMonths[key];
              if (typeof rangeIndex !== 'undefined' && this.renewalCollectionListWay[rangeIndex]) {
                this.$set(this.renewalCollectionListWay[rangeIndex], 'months', prev);
              }
            }
            return false;
          }
          return true;
        }

        // 处理单月选择器的调用
        const [type, val, index, month, subIndex] = args;
        if (typeof type === 'undefined') return true;

        // 如果删除了时间，直接返回true
        if (!val && !month) {
          return true;
        }

        const key = index + '_' + (typeof subIndex !== 'undefined' ? subIndex : 'root');

        const parseYearMonth = (input) => {
          if (!input) return null;
          if (input instanceof Date) return input;
          let s = String(input);
          if (/^\d{4}-\d{1,2}$/.test(s)) s = s + '-01';
          const d = new Date(s);
          return isNaN(d.getTime()) ? null : d;
        };

        if (!this.renewalCollectionListWay) this.renewalCollectionListWay = [];

        // 获取当前项
        const currentItem = typeof subIndex !== 'undefined' 
          ? (this.renewalCollectionListWay[index] && this.renewalCollectionListWay[index][subIndex])
          : this.renewalCollectionListWay[index];

        if (!currentItem) return true;

        // 获取当前选择的日期
        const currentDate = parseYearMonth(val);
        if (!currentDate) return true;

        // 如果是选择开始日期
        if (type === 1) {
          // 如果已有结束日期，检查日期范围
          if (currentItem.monthss) {
            const endDate = parseYearMonth(currentItem.monthss);
            if (endDate) {
              if (currentDate > endDate) {
                this.$message.warning('开始月份不能大于结束月份');
                this.$set(currentItem, 'months', '');
                return false;
              }
              // 计算月份差值
              const monthsDiff = (endDate.getFullYear() - currentDate.getFullYear()) * 12 + (endDate.getMonth() - currentDate.getMonth()) + 1;
              if (this.isShow_type === '2' && monthsDiff < 3) {
                this.$message.warning('请选择连续的三个月');
                this.$set(currentItem, 'months', '');
                return false;
              }
              if (this.isShow_type === '3' && monthsDiff < 12) {
                this.$message.warning('请选择连续的12个月');
                this.$set(currentItem, 'months', '');
                return false;
              }
            }
          }
        } 
        // 如果是选择结束日期
        else if (type === 2) {
          // 如果已有开始日期，检查日期范围
          if (currentItem.months) {
            const startDate = parseYearMonth(currentItem.months);
            if (startDate) {
              if (currentDate < startDate) {
                this.$message.warning('结束月份不能小于开始月份');
                this.$set(currentItem, 'monthss', '');
                return false;
              }
              // 计算月份差值
              const monthsDiff = (currentDate.getFullYear() - startDate.getFullYear()) * 12 + (currentDate.getMonth() - startDate.getMonth()) + 1;
              if (this.isShow_type === '2' && monthsDiff < 3) {
                this.$message.warning('请选择连续的三个月');
                this.$set(currentItem, 'monthss', '');
                return false;
              }
              if (this.isShow_type === '3' && monthsDiff < 12) {
                this.$message.warning('请选择连续的12个月');
                this.$set(currentItem, 'monthss', '');
                return false;
              }
            }
          }
        }

        // 验证通过，清理缓存的先前值
        if (this._prevMonths && this._prevMonths[key]) delete this._prevMonths[key];
        return true;
      } catch (err) {
        console.error('handleDateChange 错误:', err);
        return true;
      }
    },


    onMonthPick(val, index) {

      const date = new Date(val.minDate);
      const date2 = new Date(val.maxDate);

      const years = date2.getFullYear();
      const months = String(date2.getMonth() + 1).padStart(2, '0');
      const results = `${years}-${months}`;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const result = `${year}-${month}`;

      if (this.useResult === undefined) {
        this.useResult = true;
      } else {
        this.useResult = !this.useResult;
      }

      this.$nextTick(() => {
        
            const refs = this.$refs.monthPicker;
            let picker = null;
            
            // 获取正确的 picker 实例
            if (Array.isArray(refs)) {
              picker = refs[index];
            } else {
              picker = refs;
            }
            
            if (!picker) return;

            if (picker.hidePicker) {
              picker.hidePicker();
            } else if (picker.picker) {
              picker.picker.visible = false;
            } else if (picker.componentRef) {
              picker.componentRef.pickerVisible = false;
            }


            let finalResult;
            if (this.useResult) {
              finalResult = result;
            } else {
              finalResult = results;
            }

            console.log('最终结果:', index, finalResult);
            
            if (picker.picker) {
              picker.picker.visible = false;
              picker.picker.$forceUpdate();
            }

            this.renewalCollectionListWay[index].months = [finalResult, finalResult];
            this.$set(this.renewalCollectionListWay[index], 'months', [finalResult, finalResult]);
      });
   },


    handleTimeTypeChange(){

      if(this.type === '底薪增幅方案'){
          if(this.isShow_type === '1'){
            if(this.input4 === 1){
              this.handleTinMHandleInti(1)
            }
            if(this.input4 === 2){
              this.handleTinMHandleInti(2)
            }
         }

         if(this.isShow_type === '2'){
            if(this.input4 === 1){
              this.handleTinMHandleInti(3)
            }
            if(this.input4 === 2){
              this.handleTinMHandleInti(4)
            }
         }

         if(this.isShow_type === '3'){
            if(this.input4 === 1){
              this.handleTinMHandleInti(5)
            }
            if(this.input4 === 2){
              this.handleTinMHandleInti(6)
            }
         }
      }


      if(this.type === '现金奖励方案'){

         if(this.isShow_type === '1'){
            if(this.input4 === 1){
              this.handleTinMHandleInti(7)
            }
            if(this.input4 === 2){
              this.handleTinMHandleInti(8)
            }
         }

         if(this.isShow_type === '2'){
            if(this.input4 === 1){
              this.handleTinMHandleInti(9)
            }
            if(this.input4 === 2){
              this.handleTinMHandleInti(10)
            }
         }

         if(this.isShow_type === '3'){
            if(this.input4 === 1){
              this.handleTinMHandleInti(11)
            }
            if(this.input4 === 2){
              this.handleTinMHandleInti(12)
            }
         }
      }


    },

    handleTinMHandleInti(type){

      let copyList = this.copyList
      let copyType = this.copyType
      let renewalCollectionListWay = []


      if(type === 1){
        if(copyType === 2 && copyList.length > 0){
          let currentYear = new Date().getFullYear();
          renewalCollectionListWay = this.renewalCollectionListWay.map((itme)=>{
              return  itme.map((items)=>{
                items.monthss = `${currentYear}-12`
                return items
              })
          })

          this.renewalCollectionListWay = renewalCollectionListWay
        }
      }

     
     

      if(type === 7){
        if(copyType === 4 && copyList.length > 0){
           let currentYear = new Date().getFullYear();
           renewalCollectionListWay = this.renewalCollectionListWay.map((itme)=>{
             itme.monthss = `${currentYear}-12`
             return itme
           })

          this.renewalCollectionListWay = renewalCollectionListWay
        }
      }
      
    },

    addInput111(index){
        // 在组末追加一个仅包含业绩标准和奖励全额的新子项（不带月份）
        if (!Array.isArray(this.renewalCollectionListWay[index])) {
          this.$set(this.renewalCollectionListWay, index, [])
        }
        this.renewalCollectionListWay[index].push({ minAmount: '', maxAmount: '', commissionRate: '' })
    },

    removeItem111(index){
        // 仅在该组有多个子项时允许删除；若只有一个则不删除并提示
        if (!Array.isArray(this.renewalCollectionListWay[index])) return
        if (this.renewalCollectionListWay[index].length > 1) {
          this.renewalCollectionListWay[index].pop()
        } else {
          this.$message && this.$message.warning && this.$message.warning('当前组仅剩一个子项，无法删除')
        }
    },

    addProgramme11(){
      this.handleinitlist()
    },

    addProgramme111(){
      this.values1 = ''
      this.values2 = ''
      this.values3 = ''
      this.values4 = ''
      this.values5 = ''
      this.planList.pageNum = 1
      this.planList.pageSize = 10
      this.handleinitlist()
    },

    handleinitlist(){
        let url = this.type === '现金奖励方案' ? '/rewardPlane/queryCashRewardPlane' : '/salaryIncreasePlane/querySalaryIncreasePlane'
       
        let data = { 
          pageNo: this.planList.pageNum, 
          pageSize: this.planList.pageSize, 
          type: this.values2,
          status: this.values3,
          name: this.values1,
          // timeTypeStr: this.values4,
          // timeStateStr: this.values5,
        }

        axios.post(`${apiBaseUrl}${url}`, data ,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
          console.log(res)
          let data = res.data.data
          if(res.data.code == 200){
              this.planList.total = data.total
              this.planArrs = data.records
              // this.$message.success('查询成功')
           }else{
             this.planList.total = 0
             this.planArrs = []
           }
        }).catch((error) => {
          this.planList.total = 0
          this.planArrs = []
          console.log(error);
          this.$message.error(error)
        });
      },

      handleGetInitAll(){
        axios.get(`${apiBaseUrl}/commissionPlan/getPlaneList`,{ headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res)=>{
          let data = res.data.data
          if(res.data.code == 200){
            this.optionPlan1 = data
          }else{
            this.optionPlan1 = []
          }
        }).catch((error)=>{
           this.optionPlan1 = []
        })
      },

      removeItem11 () {
        if (this.renewalCollectionListWay.length > 1) {
            this.renewalCollectionListWay.pop()
        } else {
            this.renewalCollectionListWay.splice(0, this.renewalCollectionListWay.length)
        }
      },

      addInput11 (type) {
        let currentYear = new Date().getFullYear();

        if(this.input4 && this.isShow_type){
           if(type === '底薪增幅方案'){

              if(this.isShow_type === '1'){
                  this.renewalCollectionListWay.push([
                    {
                        months: currentYear+ '-01',
                        monthss: currentYear+ '-12',
                        minAmount:'',
                        maxAmount:'',
                        commissionRate:'',
                    }
                  ])
              }
              
              if(this.isShow_type === '2'){
                    // 计算当前已有的季度数
                  let quarterCount = this.renewalCollectionListWay.length;
                  
                  // 如果已经有4个季度（全年），不再添加
                  if(quarterCount >= 4) return this.$message.warning('已达到最大季度数');
                  
                  // 计算当前要添加的季度
                  let quarterMonths = [
                      [currentYear + '-01', currentYear + '-03'],
                      [currentYear + '-04', currentYear + '-06'],
                      [currentYear + '-07', currentYear + '-09'],
                      [currentYear + '-10', currentYear + '-12'],
                  ];
                  
                  this.renewalCollectionListWay.push([{
                      months: quarterMonths[quarterCount][0],
                      monthss: quarterMonths[quarterCount][1],
                      minAmount:'',
                      maxAmount:'',
                      commissionRate:'',
                  }]);
              }

              if(this.isShow_type === '3'){
                  this.renewalCollectionListWay.push([
                    {
                        months: currentYear+ '-01',
                        monthss: currentYear+ '-12',
                        minAmount:'',
                        maxAmount:'',
                        commissionRate:'',
                    }
                  ])
              }
           }else{

              if(this.isShow_type === '1'){
                this.renewalCollectionListWay.push({
                    months: currentYear+ '-01',
                    monthss: currentYear+ '-12',
                    minAmount:'',
                    maxAmount:'',
                    commissionRate:'',
                })
              }

              if(this.isShow_type === '2'){

                  let quarterCount = this.renewalCollectionListWay.length;
                  
                  // 如果已经有4个季度（全年），不再添加
                  if(quarterCount >= 4) return this.$message.warning('已达到最大季度数');
                  
                  // 计算当前要添加的季度
                  let quarterMonths = [
                      [currentYear + '-01', currentYear + '-03'],
                      [currentYear + '-04', currentYear + '-06'],
                      [currentYear + '-07', currentYear + '-09'],
                      [currentYear + '-10', currentYear + '-12'],
                  ];
                  
                  this.renewalCollectionListWay.push({
                      months: quarterMonths[quarterCount][0],
                      monthss: quarterMonths[quarterCount][1],
                      minAmount:'',
                      maxAmount:'',
                      commissionRate:'',
                  });
              }

              if(this.isShow_type === '3'){
                this.renewalCollectionListWay.push({
                    months: currentYear+ '-01',
                    monthss: currentYear+ '-12',
                    minAmount:'',
                    maxAmount:'',
                    commissionRate:'',
                })
              }

           }
        }else{
          this.$message.warning('请先选择时间类型 || 月 季度 年')
        }
      },


    handleseachRestAddShowSava1(type){
      let leng = this.renewalCollectionListWay.length

      if(type === '1'){
        if(leng > 0){
          this.$confirm('切换时间类型会清空已添加的方案详情，是否继续？', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',   type: 'warning' }).then(() => {
            this.renewalCollectionListWay = []
            this.isShow_type = '1'
          }).catch(() => {})
        }else{
          this.isShow_type = '1'
        }
      }

      if(type === '2'){
        if(leng > 0){
          this.$confirm('切换时间类型会清空已添加的方案详情，是否继续？', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',   type: 'warning' }).then(() => {
            this.renewalCollectionListWay = []
            this.isShow_type = '2'
          }).catch(() => {})
        }else{
          this.isShow_type = '2'
        }
      }

      if(type === '3'){
        if(leng > 0){
          this.$confirm('切换时间类型会清空已添加的方案详情，是否继续？', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',   type: 'warning' }).then(() => {
            this.renewalCollectionListWay = []
            this.isShow_type = '3'
          }).catch(() => {})
        }else{
          this.isShow_type = '3'
        }
      }

    },

    handleDateChanges(index,vale,subIndex){
      const date2 = new Date(vale);
      const years = date2.getFullYear();
      const months = String(date2.getMonth() + 1).padStart(2, '0');
      this.renewalCollectionListWay[index][subIndex].months = `${years}-${months}`
      this.$set(this.renewalCollectionListWay[index][subIndex], 'months', '')
    },

    handleseachRestAddShowSava(){

      let obj = { url:'', data:{ } }


      if(this.type === '现金奖励方案'){

        let mapsList = []
        
        console.log(this.renewalCollectionListWay)
        if(this.isShow_type === '1' ){
          mapsList = this.renewalCollectionListWay.map((item, index) => {
            console.log(item)
            let newItem = {}
            if (item.months && item.monthss && this.input4 === 1) {
              newItem.month = item.months.substring(5) + '-' + item.monthss.substring(5);
            }else{
              if (item.months instanceof Date) {
                const date1 = new Date(item.months);
                newItem.month = String(date1.getMonth() + 1).padStart(2, '0');
              } else {
                newItem.month = item.months.substring(5);
              }
            }
            newItem.standard = item.maxAmount
            newItem.rewardAmount = item.commissionRate
            return newItem
          })
        }

        if(this.isShow_type === '2' || this.isShow_type === '3'){
          mapsList = this.renewalCollectionListWay.map((item, index) => {
            let newItem = {}
            if (item.months && item.monthss) {

                let startMonth = ''
                let endMonth = ''

                if (item.months instanceof Date) {
                  const date1 = new Date(item.months);
                  startMonth = String(date1.getMonth() + 1).padStart(2, '0');
                }else{
                   startMonth = item.months.substring(5);
                }

                if (item.monthss instanceof Date) {
                  const date1 = new Date(item.monthss);
                  endMonth = String(date1.getMonth() + 1).padStart(2, '0');
                }else{
                   endMonth = item.monthss.substring(5); 
                }
              
              newItem.month = `${startMonth}-${endMonth}`;
            }
            newItem.standard = item.maxAmount
            newItem.rewardAmount = item.commissionRate
            return newItem
          })
        }


        if(this.isShows){
          obj.url = `${this.objUrl.add}`
          obj.data = { 
            name: this.input1,
            type: this.input2,
            // standard: this.maxAmount,
            cashRewardDetails: mapsList,
            timeType: this.isShow_type,
            timeState: this.input4,
          }
        }else{ 
          obj.url = `${this.objUrl.edit}`
          obj.data = { 
            id: this.ids,
            name: this.input1,
            type: this.input2,
            status: this.input3,
            // standard: this.maxAmount,
            cashRewardDetails: mapsList,
            timeType: this.isShow_type,
            timeState: this.input4,
          }
        }
      }

      if(this.type === '底薪增幅方案'){
        let newList = []


        if(this.isShow_type === '1'){
            newList = this.renewalCollectionListWay.map((item, index) => {
              const firstDetail = item[0];
              let months = '';

              if(this.input4 === 1) {
                // 处理第一个月份
                let month1 = '';
                if (firstDetail.months instanceof Date) {
                  const date = new Date(firstDetail.months);
                  month1 = String(date.getMonth() + 1).padStart(2, '0');
                } else {
                  month1 = firstDetail.months.substring(5);
                }

                // 处理第二个月份
                let month2 = '';
                if (firstDetail.monthss instanceof Date) {
                  const date1 = new Date(firstDetail.monthss);
                  month2 = String(date1.getMonth() + 1).padStart(2, '0');
                } else {
                  month2 = firstDetail.monthss.substring(5);  // 修正：使用 monthss
                }

                months = month1 + '-' + month2;
              } else {
                // 处理单个月份
                if (firstDetail.months instanceof Date) {
                  const date = new Date(firstDetail.months);
                  months = String(date.getMonth() + 1).padStart(2, '0');
                } else {
                  months = firstDetail.months.substring(5);
                }
              }

              // 返回处理后的数组
              return item.map((detail, detailIndex) => ({
                month: months,  // 所有项都使用第一项的月份
                monthSerialNum: index + 1,
                serialNum: detailIndex + 1,
                standard: detail.maxAmount,
                salaryIncreaseAmount: detail.commissionRate
              }));
            }).flat();

        }
        
        if(this.isShow_type === '2' || this.isShow_type === '3'){
           newList = this.renewalCollectionListWay.map((item, index) => {
            return item.map((detail, detailIndex) => {
              let firstDetail = item[0];
              let month = '';
              let startMonth = ''
              let endMonth = ''

              if (firstDetail.months instanceof Date) {
                const date1 = new Date(firstDetail.months);
                startMonth = String(date1.getMonth() + 1).padStart(2, '0');
              }else{
                 startMonth = firstDetail.months.substring(5);
              }

              if (firstDetail.monthss instanceof Date) {
                const date1 = new Date(firstDetail.monthss);
                endMonth = String(date1.getMonth() + 1).padStart(2, '0');
              }else{
                 endMonth = firstDetail.monthss.substring(5); 
              }
              
              month = `${startMonth}-${endMonth}`;

              return {
                month: month,
                monthSerialNum: index + 1,
                serialNum: detailIndex + 1,
                standard: detail.maxAmount,
                salaryIncreaseAmount: detail.commissionRate
              };
            });
          }).flat();
        }


        if(this.isShows){
          obj.url = `${this.objUrl.add}`
          obj.data = { 
            name: this.input1,
            type: this.input2,
            details: newList,
            timeType: this.isShow_type,
            timeState: this.input4,
          }
        }else{
          obj.url = `${this.objUrl.edit}`
          obj.data = { 
            id: this.ids,
            name: this.input1,
            type: this.input2,
            status: this.input3,
            details: newList,
            timeType: this.isShow_type,
            timeState: this.input4,
          }
        }
      }

      axios.post(`${apiBaseUrl}${obj.url}`, obj.data, { headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res)=>{
        if(res.data.code == 200){
            this.$message.success('添加成功')
            this.isShows = false
            this.addProgramme1show = false
            this.renewalCollectionListWay = []
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.maxAmount = ''
            this.commissionRate = ''
            this.input4 = ''
            this.useResult = undefined
            this.isShow_type = '1'
            this.handleinitlist()
          }else{
            this.$message.error(res.data.message)
          }
        }).catch((error)=>{
          this.$message.error(error)
      })
    },

    addProgramme1 () {
      this.ids = ''
      this.isShows = true
      this.addProgramme1show = true
    },


    handleaddProgramme1show(){
      this.isShows = false
      this.addProgramme1show = false
      this.renewalCollectionListWay = []
      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
      this.maxAmount = ''
      this.commissionRate = ''
      this.input4 = ''
      this.useResult = undefined
      this.isShow_type = '1'
    },

    handleDateChange1 (type, val, index, month) {
      if (!val) return false

      try {
        const selectedDate = new Date(val)
        if (isNaN(selectedDate.getTime())) {
          this.$message.warning('请选择有效的日期')
          return false
        }

        if (!this.renewalCollectionListWay) this.renewalCollectionListWay = []

        // helper: parse 'YYYY-MM' or Date -> Date (first day of month)
        const parseYearMonth = (input) => {
          if (!input) return null
          if (input instanceof Date) return input
          // ensure string like 'YYYY-MM' becomes 'YYYY-MM-01'
          let s = String(input)
          if (/^\d{4}-\d{1,2}$/.test(s)) s = s + '-01'
          const d = new Date(s)
          return isNaN(d.getTime()) ? null : d
        }

        const startStr = type === 1 ? val : (this.renewalCollectionListWay[index] && this.renewalCollectionListWay[index].months)
        const endStr = type === 2 ? val : (this.renewalCollectionListWay[index] && this.renewalCollectionListWay[index].monthss)

        if (startStr && endStr) {
          const start = parseYearMonth(startStr)
          const end = parseYearMonth(endStr)

          if (!start || !end) {
            this.$message.warning('请选择有效的开始和结束月份')
            // 恢复为先前值（若存在）
            const key = index + '_root'
            const prev = (this._prevMonths && this._prevMonths[key]) || {}
            if (type === 1 && this.renewalCollectionListWay[index]) this.$set(this.renewalCollectionListWay[index], 'months', prev.months === undefined ? '' : prev.months)
            if (type === 2 && this.renewalCollectionListWay[index]) this.$set(this.renewalCollectionListWay[index], 'monthss', prev.monthss === undefined ? '' : prev.monthss)
            return false
          }

          if (start > end) {
            this.$message.warning('开始月份不能大于结束月份')
            const key = index + '_root'
            const prev = (this._prevMonths && this._prevMonths[key]) || {}
            if (type === 1 && this.renewalCollectionListWay[index]) this.$set(this.renewalCollectionListWay[index], 'months', prev.months === undefined ? '' : prev.months)
            if (type === 2 && this.renewalCollectionListWay[index]) this.$set(this.renewalCollectionListWay[index], 'monthss', prev.monthss === undefined ? '' : prev.monthss)
            return false
          }

          const monthsDiff = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth())

          if (this.isShow_type === '2') {
            if (monthsDiff !== 2) {
              this.$message.warning('请选择连续的三个月')
              const key = index + '_root'
              const prev = (this._prevMonths && this._prevMonths[key]) || {}
              if (type === 1 && this.renewalCollectionListWay[index]) this.$set(this.renewalCollectionListWay[index], 'months', prev.months === undefined ? '' : prev.months)
              if (type === 2 && this.renewalCollectionListWay[index]) this.$set(this.renewalCollectionListWay[index], 'monthss', prev.monthss === undefined ? '' : prev.monthss)
              return false
            }
          }

          if (this.isShow_type === '3') {
            if (monthsDiff !== 11) {
              this.$message.warning('请选择连续的12个月')
              if (type === 1 && this.renewalCollectionListWay[index]) this.$set(this.renewalCollectionListWay[index], 'months', '')
              if (type === 2 && this.renewalCollectionListWay[index]) this.$set(this.renewalCollectionListWay[index], 'monthss', '')
              return false
            }
          }
        }

        return true
      } catch (err) {
        console.error('日期处理错误:', err)
        this.$message.warning('日期处理出错，请重试')
        return false
      }
    },




    editPlan3 (row) {
      this.ids = row.id


      this.input1 = row.name
      this.input2 = row.type
      this.input3 = row.status
      this.isShow_type = String(row.timeType)
      this.input4 = Number(row.timeState)

      console.log('编辑方案详情:', row.planDetails) 

      if(this.type === '底薪增幅方案'){
        if(row.planDetails && row.planDetails.length > 0){

            let renewalCollectionListWay = []

            if(this.isShow_type === '1' && this.input4 === 1){
              renewalCollectionListWay = row.planDetails.map((item) => {
                return item.map((items) => {
                  let createTime = items.createTime ? items.createTime.substring(0, 4) : '';
                  return {
                    months: createTime + '-' +items.startMonth,
                    monthss: createTime + '-' +items.endMonth,
                    maxAmount: items.standard,
                    commissionRate: items.salaryIncreaseAmount
                  }
                })
              })

              this.copyType = 1
            }

            if(this.isShow_type === '1' && this.input4 === 2){
              renewalCollectionListWay = row.planDetails.map((item) => {
                return item.map((items) => {
                  let createTime = items.createTime ? items.createTime.substring(0, 4) : '';
                  return {
                    months: createTime + '-' +items.startMonth,
                    maxAmount: items.standard,
                    commissionRate: items.salaryIncreaseAmount
                  }
                })
              })

              this.copyType = 2
            }

            if(this.isShow_type === '2' || this.isShow_type === '3'){
              renewalCollectionListWay = row.planDetails.map((item) => {
                return item.map((items) => {
                  let createTime = items.createTime ? items.createTime.substring(0, 4) : '';
                  return {
                    months: createTime + '-' +items.startMonth,
                    monthss: createTime + '-' +items.endMonth,
                    maxAmount: items.standard,
                    commissionRate: items.salaryIncreaseAmount
                  }
                })
              })
            }

            this.renewalCollectionListWay = renewalCollectionListWay
            this.copyList = this.renewalCollectionListWay

        }else{
          this.renewalCollectionListWay = []
          this.copyList = []
        }
      }



      if(this.type === '现金奖励方案'){
         let renewalCollectionListWay = []
        
          if(this.isShow_type === '1'){
             renewalCollectionListWay = row.cashRewardDetails ? row.cashRewardDetails.map((itme)=>{
                let createTime = itme.createTime ? itme.createTime.substring(0, 4) : '';
                if(this.input4 === 1){
                  this.copyType = 3
                  return {
                    months: createTime + '-' + itme.startMonth,
                    monthss: createTime + '-' + itme.endMonth,
                    maxAmount: itme.standard,
                    commissionRate: itme.rewardAmount
                  }
                }
                if(this.input4 === 2){
                  this.copyType = 4
                  return {
                    months: createTime + '-' + itme.startMonth,
                    maxAmount: itme.standard,
                    commissionRate: itme.rewardAmount
                  }
                }
                return itme
             }) : []
          }

          if(this.isShow_type === '2' || this.isShow_type === '3'){
             renewalCollectionListWay = row.cashRewardDetails ? row.cashRewardDetails.map((itme)=>{
                let createTime = itme.createTime ? itme.createTime.substring(0, 4) : '';
                return {
                    months: createTime + '-' + itme.startMonth,
                    monthss: createTime + '-' + itme.endMonth,
                    maxAmount: itme.standard,
                    commissionRate: itme.rewardAmount
                }
             }) : []  
          }

         this.renewalCollectionListWay = renewalCollectionListWay
         this.copyList = this.renewalCollectionListWay
      }
      

      this.isShows = false
      this.addProgramme1show = true
    },

    handleAddMembersShowClose(){
      this.moonVisible = false
    },

    seleOption () {
      console.log(this.values);
      axios
        .post(`${apiBaseUrl}/salaryPlan/salaryPlanList`, { pageNum: this.planList.pageNum, pageSize: this.planList.pageSize, planName: this.values },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.planList.total = res.data.data.total
          this.planArr = res.data.data.records
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //select搜索
    getOptions () {
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanNameList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.optionPlan = res.data.data
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取所有方案
    getPlanList () {
      axios
        .post(`${apiBaseUrl}/salaryPlan/salaryPlanList`, { pageNum: this.planList.pageNum, pageSize: this.planList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.planList.total = res.data.data.total
          this.planArr = res.data.data.records
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取小学生一对多奖励数据
    getPupilList () {
      axios
        .post(`${apiBaseUrl}/salaryPlanGradeOneMany/getList`, { pageNum: this.GradeOneManyList.pageNum, pageSize: this.GradeOneManyList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.GradeOneManyList.total = res.data.data.total
          this.GradeOneManyArr = res.data.data.records
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //小学生一对多保存
    pupilDialogSave () {
      let data = {
        month: this.checkList.toString(),
        classType: this.pupilObj.classType,
        fee: this.pupilObj.fee,
        id: this.pupilObj.id
      }
      if (this.pupilShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanGradeOneMany/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.getPupilList()
              this.pupilDialog = false
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanGradeOneMany/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.getPupilList()
              this.pupilDialog = false
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //添加方案 编辑方案保存
    saveFun () {
      let data = {
        id: this.addPlan.id,
        planName: this.addPlan.planName,
        jobBasepay: this.addPlan.jobBasepay,
        isRecommender: this.addPlan.isRecommender ? '1' : '0',
        recommenderFee: this.addPlan.recommenderFee,
        isClassFee: this.addPlan.isClassFee ? '1' : '0',
        classFeeId: this.addPlan.classFeeId,
        isGradeOneMany: this.addPlan.isGradeOneMany ? '1' : '0',
        gradeOneManyId: this.addPlan.gradeOneManyId.toString(),
        isDuty: this.addPlan.isDuty ? '1' : '0',
        dutyMonth: this.addPlan.dutyMonth,
        day: this.addPlan.day,
        dutyId: this.addPlan.dutyId,
        isExce: this.addPlan.isExce ? '1' : '0',
        execId: this.addPlan.execId.toString(),
        isExceOnemany: this.addPlan.isExceOnemany ? '1' : '0',
        exceOnemanyId: this.addPlan.exceOnemanyId.toString(),
        isExceDay: this.addPlan.isExceDay ? '1' : '0',
        exceDayId: this.addPlan.exceDayId.toString(),
        isStudentTotal: this.addPlan.isStudentTotal ? '1' : '0',
        studentTotalId: this.addPlan.studentTotalId.toString(),

        isRecommender: this.addMoon.isMoon ? 1 : 0,
        interpolateId: this.addMoon.dutyId,
        isOneClass: this.addPlan.isDay ? 1 : 0,
        oneClassId: this.addPlan.dutyId1,
        isNightEight: this.addPlan.isDuty1 ? 1 : 0,
        nightEightMoney: this.addPlan.day,

        isWayMoney: this.addPlan.isDay1 ? 1 : 0,
        wayId: this.addPlan.dutyId2,


        isExpand: this.isExpand ,
        expandFee:this.expandFee,

        //是否开启社保补助 0否 1是
        isSocialSecurity: this.socialSecurityFee ? 1 : 0,
         //社保补助
        socialSecurityFee: this.socialSecurityFee,
        //是否开启社保 0否 1是
        isSocialSecurityWithhold: this.socialSecurityWithholdFee ? 1 : 0,
        //社保
        socialSecurityWithholdFee: this.socialSecurityWithholdFee,
                
      }
      if (this.titleText == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlan/salaryPlanAdd`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getPlanList()
              this.$message.success(res.data.message)
              this.dialogVisible = false
              this.socialSecurityFee = ''
              this.isSocialSecurity = ''
              this.isSocialSecurityWithhold = ''
              this.socialSecurityWithholdFee = ''


              this.$emit('handleEvent',false)

            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlan/salaryPlanUpdate`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getPlanList()
              this.dialogVisible = false
              this.$message.success(res.data.message)
              this.socialSecurityFee = ''
              this.isSocialSecurity = ''
              this.isSocialSecurityWithhold = ''
              this.socialSecurityWithholdFee = ''
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //删除方案
    delPlan (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanDel?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getPlanList()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    editPlan1(id){
      axios.get(`${apiBaseUrl}/salaryPlan/salaryCopy?id=${id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}) .then((res) => {
        if (res.data.code == 200) {
           this.$message.success(res.data.message)
        }else{
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        this.$message.error(error)
      });
    },

    //编辑方案回显
    editPlan (id) {
      this.addPlan.id = id
      this.titleText = false
      this.dialogVisible = true
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanOne?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.addPlan.planName = res.data.data.planName
          this.addPlan.jobBasepay = res.data.data.jobBasepay
          this.addPlan.isRecommender = res.data.data.isRecommender == 1 ? true : false
          this.addPlan.isClassFee = res.data.data.isClassFee == 1 ? true : false
          this.addPlan.recommenderFee = res.data.data.recommenderFee
          this.addPlan.isExce = res.data.data.isExce == 1 ? true : false
          this.addPlan.classFeeId = res.data.data.classFeeId
          this.addPlan.isGradeOneMany = res.data.data.isGradeOneMany == 1 ? true : false


          this.addMoon.isMoon = res.data.data.isRecommender == 1 ? true : false
          this.addMoon.dutyId = res.data.data.interpolateId

          this.addPlan.isDay = res.data.data.isOneClass == 1 ? true : false
          this.addPlan.dutyId1 = res.data.data.oneClassId

          this.addPlan.isDuty1 = res.data.data.isNightEight == 1 ? true : false
          this.addPlan.day = res.data.data.nightEightMoney


          this.addPlan.isDay1 =  res.data.data.isWayMoney == 1 ? true : false
          this.addPlan.dutyId2 = res.data.data.wayId


          this.isExpand  = res.data.data.isExpand 
          this.expandFee = res.data.data.expandFee 

           //是否开启社保补助 0否 1是
          this.isSocialSecurity =  res.data.data.socialSecurityFee ? 1 : 0
          //社保补助
          this.socialSecurityFee =  res.data.data.socialSecurityFee
          //是否开启社保 0否 1是
          this.isSocialSecurityWithhold =  res.data.data.socialSecurityWithholdFee ? 1 : 0
          //社保
          this.socialSecurityWithholdFee =  res.data.data.socialSecurityWithholdFee


          let e = res.data.data.gradeOneManyId.split(",").map(Number)
          if (e.length > 0) {
            this.$nextTick(() => {
              this.GradeOneManyArr.forEach(item => {
                if (e.some(user => user === item.id)) {
                  // 存在添加
                  // this.$refs.multipleTable4.toggleRowSelection(item, true)
                }
              })
            })
          }
          this.addPlan.isDuty = res.data.data.isDuty == 1 ? true : false
          this.addPlan.dutyMonth = res.data.data.dutyMonth
          this.addPlan.day = res.data.data.day
          this.addPlan.dutyId = res.data.data.dutyId
          this.addPlan.isExce = res.data.data.isExce == 1 ? true : false
          let d = res.data.data.execId.split(",").map(Number)
          if (d.length > 0) {
            this.$nextTick(() => {
              this.ExceTableData.forEach(item => {
                if (d.some(user => user === item.id)) {
                  // 存在添加
                  // this.$refs.multipleTable3.toggleRowSelection(item, true)
                }
              })
            })
          }
          this.addPlan.isExceOnemany = res.data.data.isExceOnemany == 1 ? true : false
          let c = res.data.data.exceOnemanyId.split(",").map(Number)
          if (c.length > 0) {
            this.$nextTick(() => {
              this.onManyTableData.forEach(item => {
                if (c.some(user => user === item.id)) {
                  // 存在添加
                  // this.$refs.multipleTable2.toggleRowSelection(item, true)
                }
              })
            })
          }
          this.addPlan.isExceDay = res.data.data.isExceDay == 1 ? true : false
          let b = res.data.data.exceDayId.split(",").map(Number)
          if (b.length > 0) {
            this.$nextTick(() => {
              this.toDayTableData.forEach(item => {
                if (b.some(user => user === item.id)) {
                  // 存在添加
                  this.$refs.multipleTable1.toggleRowSelection(item, true)
                }
              })
            })
          }
          this.addPlan.isStudentTotal = res.data.data.isStudentTotal == 1 ? true : false
          let a = res.data.data.studentTotalId.split(",").map(Number)
          if (a.length > 0) {
            this.$nextTick(() => {
              this.studentCoursesTableData.forEach(item => {
                if (a.some(user => user === item.id)) {
                  // 存在添加
                  // this.$refs.multipleTable.toggleRowSelection(item, true)
                }
              })
            })
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //方案详情
    planDetailFun (id) {
      this.dialogVisible1 = true
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanDetail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.detilObj = res.data.data
          console.log(this.detilObj);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addInput () {
      this.arr.push({
        grade: "",
        educationType: "",
        classFee: ""
      });
    },
    //减少输入框
    removeItem (index) {
      // if (this.planDetail.length > 1) {
      this.arr.splice(index, 1);;
      // } else {
      //   this.planDetail.splice(0, this.planDetail.length);
      // }
    },
    //课时费添加方案
    addItem () {
      this.isShow = true
      this.showDialog = true
      this.planNames = ""
      this.arr = [{
        grade: "",
        educationType: "",
        classFee: ""
      }]
    },
    //课时费删除方案
    editItem () {
      if (this.addPlan.classFeeId != "") {
        this.isShow = false
        this.showDialog = true
        axios
          .get(`${apiBaseUrl}/salaryPlanClassFee/detail?id=${this.addPlan.classFeeId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.planNames = res.data.data.planName
              this.arr = res.data.data.planDetail
              this.planObj.id = res.data.data.id
              this.planNames = res.data.data.planName
              this.addPlan.classFeeId = ""
              this.$message.success(res.data.success)
            } else {
              this.$message.error(res.data.success)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },
    //删除
    delItem () {
      if (this.addPlan.classFeeId != "") {
        axios
          .get(`${apiBaseUrl}/salaryPlanClassFee/delete?id=${this.addPlan.classFeeId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getListArr()
              this.addPlan.classFeeId = ""
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },
    //小学生一对多奖励添加
    pupilBtn () {
      this.checkList = []
      this.pupilObj.classType = "",
        this.pupilObj.fee = ""
      this.pupilShow = true
      this.pupilDialog = true
    },
    //小学生一对多奖励表格编辑
    editPupil (id) {
      this.pupilShow = false
      this.pupilDialog = true
      this.pupilObj.id = id
      axios
        .get(`${apiBaseUrl}/salaryPlanGradeOneMany/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.checkList = res.data.data.month.split(",")
          this.pupilObj.classType = res.data.data.classType
          this.pupilObj.fee = res.data.data.fee
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //小学生一对多奖励删除
    delPupil (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanGradeOneMany/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getPupilList()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后每节课奖励表格
    getPlanExec () {
      axios
        .post(`${apiBaseUrl}/salaryPlanExec/getList`, { pageNum: this.PlanExecList.pageNum, pageSize: this.PlanExecList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.ExceTableData = res.data.data.records
          this.PlanExecList.total = res.data.data.total
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后每节课奖励添加 编辑保存
    exceedSave () {
      let data = {
        month: this.checkList2.toString(),
        basicClassNum: this.exceedObj.basicClassNum,
        excePredictFee: this.exceedObj.excePredictFee,
        id: this.exceedObj.id
      }
      if (this.exceedShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanExec/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getPlanExec()
              this.exceedDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanExec/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getPlanExec()
              this.exceedDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //超课次后每节课奖励添加
    exceedBtn () {
      this.checkList2 = []
      this.exceedObj.basicClassNum = ""
      this.exceedObj.excePredictFee = ""
      this.exceedShow = true
      this.exceedDialog = true
    },
    //超课次后每节课奖励编辑
    EditXceed (id) {
      this.exceedObj.id = id
      this.exceedShow = false
      this.exceedDialog = true
      axios
        .get(`${apiBaseUrl}/salaryPlanExec/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.exceedObj.basicClassNum = res.data.data.basicClassNum
          this.checkList2 = res.data.data.month.split(",")
          this.exceedObj.excePredictFee = res.data.data.excePredictFee
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次表格删除
    delXceed (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanExec/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getPlanExec()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后一对多奖励表格
    getOnMany () {
      axios
        .post(`${apiBaseUrl}/salaryPlanExceOnemany/getList`, { pageNum: this.onManyList.pageNum, pageSize: this.onManyList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.onManyTableData = res.data.data.records
          this.onManyList.total = res.data.data.total
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后一对多奖励添加
    onManyAdd () {
      this.checkList3 = []
      this.onManyObj.basicClassNum = ""
      this.onManyObj.grade = ""
      this.onManyObj.classType = ""
      this.onManyObj.fee = ""
      this.onManyShow = true
      this.onManyDialog = true
    },
    //超课次后一对多奖励编辑
    onManyEdit (id) {
      this.onManyShow = false
      this.onManyDialog = true
      this.onManyObj.id = id
      axios
        .get(`${apiBaseUrl}/salaryPlanExceOnemany/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.checkList3 = res.data.data.month.split(",")
          this.onManyObj.basicClassNum = res.data.data.basicClassNum
          this.onManyObj.grade = res.data.data.grade
          this.onManyObj.classType = res.data.data.classType
          this.onManyObj.fee = res.data.data.fee
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后一对多奖励删除
    delOnMany (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanExceOnemany/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getOnMany()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.success)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后一对多奖励 添加 编辑 保存
    onmanySave () {
      let data = {
        month: this.checkList3.toString(),
        basicClassNum: this.onManyObj.basicClassNum,
        grade: this.onManyObj.grade,
        id: this.onManyObj.id,
        fee: this.onManyObj.fee,
        classType: this.onManyObj.classType
      }
      if (this.onManyShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanExceOnemany/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getOnMany()
              this.onManyDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanExceOnemany/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getOnMany()
              this.onManyDialog = false
              this.$message.success(res.data.success)
            } else {
              this.$message.error(res.data.success)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //当天超课次奖励添加
    todayAdd () {
      this.checkList4 = []
      this.toDayObj.dayExceClassFee = ""
      this.toDayObj.dayExceClassNum = ""
      this.toDayShow = true
      this.toDayDialog = true
    },
    //当天超课次奖励编辑
    toDatEdit (id) {
      this.toDayShow = false
      this.toDayDialog = true
      this.toDayObj.id = id
      axios
        .get(`${apiBaseUrl}/salaryPlanExceDay/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.checkList4 = res.data.data.month.split(",")
          this.toDayObj.dayExceClassFee = res.data.data.dayExceClassFee
          this.toDayObj.dayExceClassNum = res.data.data.dayExceClassNum
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //当天超课次删除
    delToDay (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanExceDay/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getToDay()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //当天超课次添加编辑保存
    toDaySave () {
      let data = {
        month: this.checkList4.toString(),
        dayExceClassFee: this.toDayObj.dayExceClassFee,
        dayExceClassNum: this.toDayObj.dayExceClassNum,
        id: this.toDayObj.id
      }
      if (this.toDayShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanExceDay/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getToDay()
              this.toDayDialog = false
              this.$message.success(res.data.success)
            } else {
              this.$message.error(res.data.success)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanExceDay/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getToDay()
              this.toDayDialog = false
              this.$message.success(res.data.success)
            } else {
              this.$message.error(res.data.success)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //获取当天超课次奖励数据
    getToDay () {
      axios
        .post(`${apiBaseUrl}/salaryPlanExceDay/getList`, { pageSize: this.toDayList.pageSize, pageNum: this.toDayList.pageNum },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.toDayTableData = res.data.data.records
          this.toDayList.total = res.data.data.total
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取学生课程累计表格
    getStudentCourses () {
      axios
        .post(`${apiBaseUrl}/salaryPlanStudentTotal/getList`, { pageNum: this.studentCoursesList.pageNum, pageSize: this.studentCoursesList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.studentCoursesTableData = res.data.data.records
          this.studentCoursesList.total = res.data.data.total
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //学生课程累计添加
    studentCoursesAdd () {
      this.checkList5 = []
      this.studentCoursesObj.classTimeNum = ""
      this.studentCoursesObj.classTimeFee = ""
      this.studentCoursesShow = true
      this.studentCoursesDialog = true
    },
    //学生课程累计编辑
    studentCoursesEdit (id) {
      this.studentCoursesShow = false
      this.studentCoursesDialog = true
      this.studentCoursesObj.id = id
      axios
        .get(`${apiBaseUrl}/salaryPlanStudentTotal/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.checkList5 = res.data.data.month.split(",")
          this.studentCoursesObj.classTimeFee = res.data.data.classTimeFee
          this.studentCoursesObj.classTimeNum = res.data.data.classTimeFee
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //学生课程累计添加 编辑 保存
    studentCoursesSave () {
      let data = {
        month: this.checkList5.toString(),
        classTimeFee: this.studentCoursesObj.classTimeFee,
        classTimeNum: this.studentCoursesObj.classTimeNum,
        id: this.studentCoursesObj.id
      }
      if (this.studentCoursesShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanStudentTotal/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getStudentCourses()
              this.studentCoursesDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanStudentTotal/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getStudentCourses()
              this.studentCoursesDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //学生课程累计删除
    delStudent (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanStudentTotal/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getStudentCourses()
            this.$message.success(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取所有课时费方案
    getPlanData () {
      axios
        .post(`${apiBaseUrl}/salaryPlanClassFee/getList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            // this.PlanDutyList = res.data.data.records
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取义务课列表
    salaryPlanDuty () {
      axios.get(`${apiBaseUrl}/oneClass/getList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
           this.PlanDutyList1 = res.data.data
        })
        .catch((error) => {
          console.log(error);
        });


      axios.post(`${apiBaseUrl}/salaryPlanDuty/getList`, { pageNum: 1, pageSize: 10 },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.PlanDutyList = res.data.data.records
        })
        .catch((error) => {
          console.log(error);
        });



       this.handleGETway_plan()

    },


    handleGETway_plan(){
        axios.get(`${apiBaseUrl}/way_plan/getList`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          this.PlanDutyList2 = res.data.data
        }).catch((error) => {});
    },

    //义务课方案添加
    addObligation () {
      this.obligationShow = true
      this.obligationDialog = true
      this.dutyClassFee = ""
      this.dutyClassNum = ""
      this.dutyObj.id = ""
    },

    addObligation1 () {
      this.oneClassType = 'add'
      this.obligationShow1 = true
      this.obligationDialog1 = true
      this.dutyObj.dutyClassFee = ""
      this.dutyObj.dutyClassNum = ""
      this.addObj.interpolateName = ''
      this.addObj.planList = []
    },

    addObligation2 () {
      this.oneClassType = 'add'
      this.obligationShow2 = true
      this.obligationDialog2 = true
      this.dutyObj.dutyClassFee = ""
      this.dutyObj.dutyClassNum = ""
      this.addObj1.interpolateName = ''
      this.addObj1.planList = []
    },

    //义务课方案编辑
    editObligation () {
      if (this.addPlan.dutyId) {
          this.obligationShow = false
          this.obligationDialog = true
          axios.get(`${apiBaseUrl}/salaryPlanDuty/detail?id=${this.addPlan.dutyId}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                this.dutyObj.id = res.data.data.id
                this.dutyClassFee = res.data.data.dutyClassNum
                this.dutyClassNum = res.data.data.dutyClassFee
          })
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    editObligation1 () {
      this.oneClassType = ''
      this.obligationDialog1 = true
      this.obligationShow1 = false
      if (this.addPlan.dutyId1) {
          // this.obligationShow = false
          // this.obligationDialog = true
          axios.get(`${apiBaseUrl}/oneClass/oneClassDetails/${this.addPlan.dutyId1}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            this.dutyObj = res.data.data
            this.addObj.planList = res.data.data.oneClassPlanDTOList
            this.addObj.interpolateName = res.data.data.oneClassName
          })
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    editObligation2 () {
      this.oneClassType = ''

      if (this.addPlan.dutyId2) {
          this.obligationDialog2 = true
          this.obligationShow2 = false
          // this.obligationShow = false
          // this.obligationDialog = true
          axios.get(`${apiBaseUrl}/way_plan/wayDetails/${this.addPlan.dutyId2}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            this.dutyObj = res.data.data
            this.addObj1.planList = res.data.data.wayPlanDTOList
            this.addObj1.interpolateName = res.data.data.wayMoneyName
            this.addObj1.interpolateNames = res.data.data.educationType
          })
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    delObligation2(){
      if (this.addPlan.dutyId2) {
        axios.delete(`${apiBaseUrl}/way_plan/delete/${this.addPlan.dutyId2}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }) .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.addPlan.dutyId2 = ""
              axios.get(`${apiBaseUrl}/way_plan/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                this.PlanDutyList2 = res.data.data
              })
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    //义务课时删除
    delObligation () {
      if (this.addPlan.dutyId != '') {
        axios
          .get(`${apiBaseUrl}/salaryPlanDuty/delete?id=${this.addPlan.dutyId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.addPlan.dutyId = ""
              this.salaryPlanDuty()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    delObligation1 () {
      if (this.addPlan.dutyId1) {
        axios.delete(`${apiBaseUrl}/oneClass/delete/${this.addPlan.dutyId1}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }) .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.addPlan.dutyId1 = ""
              axios.get(`${apiBaseUrl}/oneClass/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                this.PlanDutyList1 = res.data.data
              })
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    obligationDialogCle(){
      this.obligationDialog = false
      this.dutyClassFee = ""
      this.dutyClassNum = ""
    },

    obligationSave1(){
      if(this.oneClassType === 'add'){
        axios.post(`${apiBaseUrl}/oneClass/add`,{ oneClassName:this.addObj.interpolateName, oneClassPlanList:JSON.stringify(this.addObj.planList)},{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            if(res.data.code === 200){
                this.$message.success('添加成功~')
                axios.get(`${apiBaseUrl}/oneClass/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                  this.PlanDutyList1 = res.data.data
                })
                this.obligationDialog1 = false
              }
              else{
                this.$message.error('添加失败~')
              }
        })
      }else{
        axios.put(`${apiBaseUrl}/oneClass/update`,{ id: this.addPlan.dutyId1, oneClassName:this.addObj.interpolateName, oneClassPlanList:JSON.stringify(this.addObj.planList)},{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          if(res.data.code === 200){
                this.$message.success('修改成功~')
                axios.get(`${apiBaseUrl}/oneClass/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                  this.PlanDutyList1 = res.data.data
                })
                this.obligationDialog1 = false
              }
              else{
                this.$message.error('修改失败~')
              }
        })
      }
    },

    obligationSave2(){
      if(this.oneClassType === 'add'){
        axios.post(`${apiBaseUrl}/way_plan/add`,{ educationType:this.addObj1.interpolateNames , wayMoneyName:this.addObj1.interpolateName, wayPlanList:JSON.stringify(this.addObj1.planList)},{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            if(res.data.code === 200){
                this.$message.success('添加成功~')
                axios.get(`${apiBaseUrl}/way_plan/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                  this.PlanDutyList2 = res.data.data
                })
                this.obligationDialog2 = false
              }
              else{
                this.$message.error('添加失败~')
              }
        })
      }else{
        axios.put(`${apiBaseUrl}/way_plan/update`,{ educationType:this.addObj1.interpolateNames, id: this.addPlan.dutyId2, wayMoneyName:this.addObj1.interpolateName, wayPlanList:JSON.stringify(this.addObj1.planList)},{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          if(res.data.code === 200){
                this.$message.success('修改成功~')
                axios.get(`${apiBaseUrl}/way_plan/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                  this.PlanDutyList2 = res.data.data
                })
                this.obligationDialog2 = false
              }
              else{
                this.$message.error('修改失败~')
              }
        })
      }
    },

    obligationDialogCle1(){
      this.obligationShow1 = false
      this.obligationDialog1 = false
    },

    obligationDialogCle2(){
      this.obligationShow2 = false
      this.obligationDialog2 = false

      this.addObj1 =  {  interpolateName: "",  interpolateNames: "",  planList: [],  }
    },

    //义务课时方案添加  编辑 保存
    obligationSave () {
      let data = {
        dutyClassFee: this.dutyClassNum,
        id: this.dutyObj.id,
        dutyClassNum: this.dutyClassFee
      }
      if (this.obligationShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanDuty/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.salaryPlanDuty()
              this.obligationDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
            console.log(res, "添加");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanDuty/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.salaryPlanDuty()
              this.obligationDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
            console.log(res, '编辑');
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    // 添加当月内推
    addMoonInterpolat(){

      this.addObj.interpolateName = ''
      this.addObj.planList = []

      this.isShowDialog = true
      this.moonVisible = true

    },
     //确定
    determine () {
      this.addObj.planList[this.index].classNum = this.num + '---' + this.num1
      this.num = 0
      this.num1= 0
      this.isMoonShow = false

    },

     //确定
     determine1 () {
        this.addObj1.planList[this.index].classNum = this.num + '---' + this.num1
        this.num = 0
        this.num1= 0
        this.isMoonShow = false
     },
    clickInp1(index){
      this.index = index
      this.isMoonShow = true
    },

    clickInp(index){
      this.index = index
      this.isMoonShow = true
    },

    clickText () {
    this.num1 = this.text
  },
    addInput1 () {
    this.addObj.planList.push({
      classNum: "",
      classPrice: ''
    });
  },

  addInput2 () {
    this.addObj1.planList.push({
      classNum: "",
      classPrice: '',
      phaseOfStudying: '',
    });
  },
  //减少输入框
  removeItem1 () {
    // if (this.addList.length > 1) {
    this.addObj.planList.pop();
    // } else {
    //   this.addList.splice(0, this.addList.length);
    // }
  },
  removeItem2 () {
    this.addObj1.planList.pop();
  },
  // 编辑当月内推
    editMoonInterpolat(){
      console.log(this.addMoon.dutyId);
      if (this.addMoon.dutyId != '') {
        this.isShowDialog= false
        this.moonVisible = true
        axios
          .get(`${apiBaseUrl}/interpolate/interpolateDetails/${this.addMoon.dutyId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            console.log(res,'回显')
            this.addObj.interpolateName = res.data.data.interpolateName
            this.addObj.planList = res.data.data.interpolatePlanDTOList
            // this.dutyObj = res.data.data
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },
    delMoonInterpolat(){
      if (this.addMoon.dutyId != '') {
        axios.delete(`${apiBaseUrl}/interpolate/delete/${this.addMoon.dutyId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            console.log(res,'删除成功')
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.addMoon.dutyId = ""
              this.getMoonInterpolatList()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },
    determinePlan(){
        if(this.isShowDialog){
          axios.post(`${apiBaseUrl}/interpolate/add`,{ interpolateName:this.addObj.interpolateName, interpolatePlanList:JSON.stringify(this.addObj.planList)},{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
            if(res.data.code === 200){
                this.$message.success('添加成功~')
                this.getMoonInterpolatList()
                this.moonVisible = false
            }else{
                this.$message.error('添加失败~')
            }
          })
        }else{
          axios.put(`${apiBaseUrl}/interpolate/update`,{ id: this.addMoon.dutyId, interpolateName:this.addObj.interpolateName, interpolatePlanList:JSON.stringify(this.addObj.planList)},{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
            if(res.data.code === 200){
                this.$message.success('添加成功~')
                this.getMoonInterpolatList()
                this.moonVisible = false
            }else{
                this.$message.error(res.data.message)
              }
          })
      }


    },
    //获取当月内推奖励列表
    getMoonInterpolatList(){
      axios.get(`${apiBaseUrl}/interpolate/getList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          console.log(res,'获取当月内推奖励列表')
          this.MoonInterpolatList = res.data.data
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取课时费列表
    getListArr () {
      axios
        .post(`${apiBaseUrl}/salaryPlanClassFee/getList`, { pageNum: 1, pageSize: 10 },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.planDetails = res.data.data.records
        })
    },
    //课时费添加 编辑保存
    showSava () {
      if (this.isShow == true) {
        //添加方法方法
        axios
          .post(`${apiBaseUrl}/salaryPlanClassFee/add`, { planName: this.planNames, planDetail: this.arr },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.showDialog = false
              this.$message.success(res.data.message)
              this.getListArr()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        //编辑保存方法
        axios
          .post(`${apiBaseUrl}/salaryPlanClassFee/update`, { planName: this.planNames, planDetail: this.arr, id: this.addPlan.classFeeId },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.showDialog = false
              this.$message.success(res.data.message)
              this.getListArr()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    handleSelectionChange (selection) {
      this.addPlan.gradeOneManyId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },
    handleSelectionChange1 (selection) {
      this.addPlan.execId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },
    handleSelectionChange2 (selection) {
      this.addPlan.exceOnemanyId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },

    handleSelectionChange3 (selection) {
      this.addPlan.exceDayId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },

    handleSelectionChange4 (selection) {
      this.addPlan.studentTotalId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },
    //添加方案按钮
    addProgramme () {
      this.addPlan.dutyId = '',//义务课时费表id
        this.addPlan.planName = "",//方案名称
        this.addPlan.isRecommender = false,//是否选了内推奖励
        this.addPlan.recommenderFee = "",//内推奖励金额
        this.addPlan.day = "",
        this.addPlan.isDuty = false,
        this.addPlan.isClassFee = false,
        this.addPlan.execId = [],//超课次表id
        this.addPlan.jobBasepay = "",//底薪
        this.addPlan.classFeeId = "",//课时费表id
        this.addPlan.dutyMonth = "",//义务课时费有效期
        this.addPlan.isGradeOneMany = false,//是否选了小学生一对多 0否 1是
        this.addPlan.isExce = false,//是否选了超课次 0否 1是
        this.addPlan.isExceOnemany = false,//是否选了超课次后一对多奖励 0否 1是
        this.addPlan.isExceDay = false,//是否选了当天超课次 0否 1是
        this.addPlan.isStudentTotal = false,//是否选了学生课程累计 0否 1是
        this.addPlan.exceDayId = [],//当天超课次表id
        this.addPlan.exceOnemanyId = [],//超课次一对多奖励表id
        this.addPlan.gradeOneManyId = [],//小学生一对多表id
        this.addPlan.studentTotalId = []//学生课程累计表id
      this.titleText = true
      this.dialogVisible = true
    },

    dialogVisibleCle(){
      // this.$emit('handleEvent',false)
      this.addMoon.isMoon = false
      this.addMoon.dutyId = ''

      this.addPlan.isDay =  false
      this.addPlan.dutyId1 = ''

      this.addPlan.isDuty1 = false
      this.addPlan.day = ''

      this.dialogVisible = false

      this.expandFee  = ''
      this.isExpand  = 0


    },
    clickitem (val) {
      val != this.addPlan.classFeeId ? val == this.addPlan.classFeeId ? this.addPlan.classFeeId = '' : this.addPlan.classFeeId = val : this.addPlan.classFeeId = ""
    },
    clickitem1 (val) {
      val != this.addPlan.dutyId ? val == this.addPlan.dutyId ? this.addPlan.dutyId = '' : this.addPlan.dutyId = val : this.addPlan.dutyId = ""
    },
    clickitem11 (val) {
      val != this.addPlan.dutyId1 ? val == this.addPlan.dutyId1 ? this.addPlan.dutyId1 = '' : this.addPlan.dutyId1 = val : this.addPlan.dutyId1 = ""
    },
    clickitem111 (val) {
      val != this.addPlan.dutyId2 ? val == this.addPlan.dutyId2 ? this.addPlan.dutyId2 = '' : this.addPlan.dutyId2 = val : this.addPlan.dutyId2 = ""
    },
    clickitemtwo(val){
      val != this.addMoon.dutyId ? val == this.addMoon.dutyId ? this.addMoon.dutyId = '' : this.addMoon.dutyId = val : this.addMoon.dutyId = ""
    },
    //所有方案分页
    handleSizeChange (val) {
      this.planList.pageSize = val;
      this.handleinitlist()
      // console.log(val);
    },
    handleCurrentChange (v) {
      // console.log(v);
      this.planList.pageNum = v;
      // this.getPlanList();
      this.handleinitlist()
    },
    //所有方案分页
    handleSizeChange1 (val) {
      // console.log(val);
    },
    handleCurrentChange1 (v) {
      this.GradeOneManyList.pageNum = v;
      // this.getPupilList();
      this.handleinitlist()
    },
    //所有方案分页
    handleSizeChange2 (val) {
      // console.log(val);
    },
    handleCurrentChange2 (v) {
      this.PlanExecList.pageNum = v;
      this.getPlanExec();
    },
    //所有方案分页
    handleSizeChange3 (val) {
      // console.log(val);
    },
    handleCurrentChange3 (v) {
      this.onManyList.pageNum = v;
      this.getOnMany();
    },
    //所有方案分页
    handleSizeChange4 (val) {
      // console.log(val);
    },
    handleCurrentChange4 (v) {
      this.toDayList.pageNum = v;
      this.getToDay();
    },
    //所有方案分页
    handleSizeChange5 (val) {
      // console.log(val);
    },
    handleCurrentChange5 (v) {
      this.studentCoursesList.pageNum = v;
      this.getStudentCourses();
    },
  }
}
</script>

<style scoped lang="less">


/deep/ .el-collapse-item{
  padding-left: 20px;
}
.demo-form-inline {
  display: flex;
}

/deep/ .el-radio__input {
  position: absolute;
  left: -20px;
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}


 /deep/ .el-collapse-item__header {
  font-size: 15px !important;
  font-weight: 900;
}


  
</style>



// WEBPACK FOOTER //
// src/SalescompensationAll/rewardSchemeType.vue